import * as React from 'react';
import {
  Select, Heading, Button, Row, Col,
} from '@elevationscu/ui-component-lib';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faX } from '@fortawesome/free-solid-svg-icons';
import { COUNTIES, BLANK_COUNTY } from './constants';
import styles from './loan-timeline.module.scss';
import InputRequest from './input-request';
import ProgressBar from './ProgressBar';
import DataDisclaimer from './data-disclaimer';

export default function LoanTimeline({
  pageNumber, userInfo, setUserInfo, nextPage, previousPage, maxPages,
}) {
  const [chosenCounties, setChosenCounties] = React.useState([]);
  const [validatedTime, setValidatedTime] = React.useState(false);
  const [selectedTime, setSelectedTime] = React.useState();
  const [selectValue, setSelectValue] = React.useState({ county: null });
  const timeOptions = ["I've chosen a house", "I'm actively looking", 'In next three months', 'Just exploring my options'];

  React.useEffect(() => {
    // sets the state if it exists, in the event a prospect has returned to a previous page
    if (userInfo.application_data.selected_counties) setChosenCounties(userInfo.application_data.selected_counties);
    if (userInfo.application_data.loan_timeline) setSelectedTime(userInfo.application_data.loan_timeline);
    if (userInfo.application_data.loan_timeline) setValidatedTime(true);
  }, [userInfo.application_data]);

  // React.useEffect(() => {
  //   userInfo.application_data = Object.assign(userInfo.application_data, {
  //     selected_counties: chosenCounties,
  //     loan_timeline: selectedTime,
  //   });
  //   setUserInfo(userInfo);
  // }, [chosenCounties, selectedTime, userInfo, setUserInfo]);

  function next() {
    userInfo.application_data = Object.assign(userInfo.application_data, {
      selected_counties: chosenCounties,
    });
    setUserInfo(userInfo);
    nextPage(userInfo);
  }

  function previous() {
    userInfo.application_data = Object.assign(userInfo.application_data, {
      selected_counties: chosenCounties,
      loan_timeline: selectedTime,
    });
    setUserInfo(userInfo);
    previousPage(userInfo);
  }

  function prospectiveTime(time) {
    setValidatedTime(true);
    setSelectedTime(time);
    userInfo.application_data = Object.assign(userInfo.application_data, {
      loan_timeline: time,
    });
    setUserInfo(userInfo);
  }

  function addCounty(e) {
    const selectedCounty = e.target.value;
    if (selectedCounty !== BLANK_COUNTY) {
      if (!chosenCounties?.includes(selectedCounty)) {
        const allCounties = [...chosenCounties, selectedCounty];
        setChosenCounties(allCounties);
        setSelectValue({
          ...selectValue,
          county: null,
        });
        userInfo.application_data = Object.assign(userInfo.application_data, {
          selected_counties: allCounties,
        });
        setUserInfo(userInfo);
      } else {
        setSelectValue({
          ...selectValue,
          county: null,
        });
      }
    }
  }

  function removeCounty(chosenCounty) {
    const index = chosenCounties.indexOf(chosenCounty);
    if (index > -1) {
      const clonedCounties = chosenCounties.slice();
      clonedCounties.splice(index, 1);
      setChosenCounties(clonedCounties);
      userInfo.application_data = Object.assign(userInfo.application_data, {
        selected_counties: clonedCounties,
      });
      setUserInfo(userInfo);
    }
  }

  return (
    <div className={styles.mainContainer}>
      <div className={styles.coreData}>
        <div className={styles.coreHeader}>
          <Heading element="h1" size={2} className={styles.dataFormHeader}>
            Let's discuss your purchase
          </Heading>
          <InputRequest />
        </div>
        <div className={styles.prospectInput}>
          <ProgressBar
            pageNumber={pageNumber}
            maxPages={maxPages}
          />
          <Heading element="h2" size={3} className={styles.heading}>
            Where do you think you will buy? (optional)
          </Heading>
          <p>
            Use the county dropdown for as many counties you might be interested in.
          </p>
          <Row className={styles.container}>
            <Col xs={12} lg={4} className={styles.containerColumn}>
              <Select label="County" value={selectValue} onClick={(e) => addCounty(e)} onChange={(e) => addCounty(e)} id="countySelect" onScroll={(e) => e.target.focus()}>
                <Select.Option selected value={null}>Choose a county</Select.Option>
                {COUNTIES.map((county) => <Select.Option value={county} label={county} id={county} aria-label={county}>{county}</Select.Option>)}

              </Select>
            </Col>
            <Col>
              {chosenCounties && chosenCounties?.length > 0 && chosenCounties.map((chosenCounty) => (
                <Button
                  variant="secondary"
                  onClick={() => removeCounty(chosenCounty)}
                  id={`btn_${chosenCounty}`}
                  className={styles.countyButton}
                  aria-label={`Click to remove ${chosenCounty} county`}
                >
                  {chosenCounty}
                  <FontAwesomeIcon icon={faX} size="xs" className={styles.icon} />
                </Button>
              ))}

            </Col>
          </Row>
          <fieldset className={styles.fieldset}>
            <legend>
              <Heading element="h2" size={3}>
                When do you think you will buy? (required)
              </Heading>
            </legend>
            <div role="radiogroup" aria-required="true" className={styles.radioButtons}>
              {timeOptions.map((time) => (
                <Button
                  id={`btn_${time}`}
                  onClick={() => prospectiveTime(time)}
                  variant="secondary"
                  className={selectedTime === time ? styles.chosenTimelineButton : styles.timelineButton}
                  aria-label={time}
                  aria-hidden="true"
                  role="radio"
                  aria-checked={validatedTime && selectedTime === time}
                  required="required"
                >
                  {time}
                </Button>
              ))}
            </div>
          </fieldset>
          <Row className={styles.rowSpacing}>
            <Col lg={8}>
              <DataDisclaimer />
            </Col>
            <Col className={styles.colSpacing}>
              <button onClick={previous} className={styles.previousButton} id="countyPreviousbtn" aria-label="previous button" type="button">
                Previous
              </button>
              <Button onClick={next} disabled={!validatedTime} className={styles.nextButton} id="countyNextbtn">
                Next
              </Button>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
}
